import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IServerErrorResponse } from '../../types';

export const useGetEstimatedArrivalQuery = (customerId: string, onClearAccounts?: () => void) => useQuery('estimate-arrival', async () => {
  const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/ach/estimated`);
  return data;
}, {
  enabled: false,
  onError: (e: IServerErrorResponse) => {
    const EXPIRED_LINKED_TOKEN_ERRORS = [4252, 4253, 4255];
    const errorCode = e?.response?.data?.errors?.[0]?.code;
    if (EXPIRED_LINKED_TOKEN_ERRORS.includes(errorCode)) {
      if (onClearAccounts) onClearAccounts();
    }
  },
});
